import { render, staticRenderFns } from "./ListScientific_specialty.vue?vue&type=template&id=4b902691&scoped=true"
import script from "./ListScientific_specialty.vue?vue&type=script&lang=js"
export * from "./ListScientific_specialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b902691",
  null
  
)

export default component.exports